<div class="modal-container">
  <mat-toolbar class="modal-header">
    <div class="header-content">
      <h1 class="modal-title">
        @if (userFullName) {
          {{ "generic.loaded_evidences_of" | translate }} <span>{{ userFullName }}</span>
        } @else {
          {{ "components.decision-table.new-decision-table.compile-proposal.loaded-evidences" | translate }}
        }
      </h1>
      <button mat-icon-button class="close-btn" (click)="closeDialogue()" [matTooltip]="'generic.buttons.close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <div class="modal-body">
    @if (attachments.length > 0) {
      <div class="table-card">
        <table mat-table [dataSource]="attachments">

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>{{ "generic.title" | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <div class="title-cell">
                <mat-icon class="file-icon" [class.pubmed]="element.type === 'PUBMED'">
                  {{ element.type === 'PUBMED' ? 'article' : 'insert_drive_file' }}
                </mat-icon>
                <a [href]="element.link" target="_blank" class="document-link">{{element.title}}</a>
              </div>
            </td>
          </ng-container>

          <!-- Type Column -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>{{ "generic.type" | translate }}</th>
            <td mat-cell *matCellDef="let element">
              <span class="type-badge" [class.badge-pubmed]="element.type === 'PUBMED'" [class.badge-file]="element.type === 'FILE'">
                {{element.type}}
              </span>
            </td>
          </ng-container>

          <!-- Date Column -->
          <ng-container matColumnDef="loaded_at">
            <th mat-header-cell *matHeaderCellDef>{{ "generic.upload_date" | translate }}</th>
            <td mat-cell *matCellDef="let element" class="date-cell">
              {{ element.created_at | formatdate | date : 'short'}}
            </td>
          </ng-container>

          <!-- Actions Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element; let i = index" class="actions-cell">
              <div class="d-flex align-items-center gap-1">
                <a [href]="element.link" target="_blank" mat-icon-button color="primary" [matTooltip]="'generic.view' | translate">
                  <mat-icon>open_in_new</mat-icon>
                </a>
                @if (editable) {
                  <button mat-icon-button color="warn" (click)="deleteAttachment(i)" [matTooltip]="'generic.remove' | translate">
                    <mat-icon>delete</mat-icon>
                  </button>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index" class="evidence-row"></tr>
        </table>
      </div>
    } @else {
      <div class="empty-state">
        <mat-icon>folder_off</mat-icon>
        <p>{{ "generic.no-attachments-uploaded" | translate }}</p>
      </div>
    }
  </div>

  @if (editable) {
    <div class="modal-footer d-flex justify-content-end gap-2 p-3">
      <button mat-raised-button color="primary" class="d-flex align-items-center" [matMenuTriggerFor]="menuAttachment">
        <mat-icon class="mr-2">add</mat-icon>
        {{ 'generic.add' | translate }}
      </button>
      <mat-menu #menuAttachment="matMenu">
        <button mat-menu-item (click)="onClickAddNewEvidence('PUBMED')">
          <mat-icon aria-hidden="false" class="attachment-evidence-icon">article</mat-icon>
          Pubmed
        </button>
        <button mat-menu-item (click)="onClickAddNewEvidence('FILE')">
          <mat-icon aria-hidden="false" class="attachment-evidence-icon">upload_file</mat-icon>
          File
        </button>
      </mat-menu>
    </div>
  }
</div>
